import _ from 'lodash';

const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const sortFunction = (hours: any) => {
  const sortByDay = (a: any, b: any) => {
    return days.indexOf(a.day) - days.indexOf(b.day);
  };

  const newHour = _.cloneDeep(hours);
  const availableHours = newHour.sort(sortByDay);

  return availableHours;
};

export const getIsFirstRow = (availableHours: any, num: number) => {
  if (num === 0) {
    return true;
  }
  if (num > 0) {
    if (availableHours[num].day !== availableHours[num - 1].day) {
      return true;
    }
  }
  return false;
};
